WiseMetering.Collection.Folders = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.Folder,
    url: '/folders',

    roots: function() {
        return new WiseMetering.Collection(this.where({ parent_id: null }));
    }
});
